import { requestJson } from '../documents/api';
import type { FetchLike } from '../documents/api';
import { buildJournalQuery } from './entries';
import type { JournalEntry, JournalFilters } from './entries';

export interface JournalPage {
  items: JournalEntry[];
  total: number;
  page: number;
  pageSize: number;
}

export async function loadJournal(
  fetcher: FetchLike,
  filters: JournalFilters,
  page: number,
  pageSize: number,
): Promise<JournalPage> {
  const query = buildJournalQuery(filters);
  const paging = `page=${page}&pageSize=${pageSize}`;
  return requestJson<JournalPage>(fetcher, `/journal?${query === '' ? paging : `${query}&${paging}`}`);
}
